"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _List = require("./List");

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var Reward = function Reward(_ref) {
  var reward = _ref.reward;
  return _react.default.createElement("span", {
    className: "reward"
  }, reward.useCount ? reward.count : null, " ", reward.useCount && reward.count > 1 && reward.pluralTitle ? reward.pluralTitle : reward.title);
};

var RewardList = function RewardList(_ref2) {
  var rewards = _ref2.rewards;

  switch (rewards.length) {
    case 1:
      return _react.default.createElement("span", null, _react.default.createElement(Reward, {
        reward: rewards[0]
      }));

    case 2:
      return _react.default.createElement("span", null, _react.default.createElement(Reward, {
        reward: rewards[0]
      }), ' and ', _react.default.createElement(Reward, {
        reward: rewards[1]
      }));

    case 3:
      return _react.default.createElement("span", null, _react.default.createElement(Reward, {
        reward: rewards[0]
      }), ",", _react.default.createElement(Reward, {
        reward: rewards[1]
      }), ' and ', _react.default.createElement(Reward, {
        reward: rewards[2]
      }));

    default:
      return _react.default.createElement("span", null, _react.default.createElement(Reward, {
        reward: rewards[0]
      }), ",", _react.default.createElement(Reward, {
        reward: rewards[1]
      }), ",", ' and ', rewards.length - 2, " more rewards");
  }
};

var CourseCompletedItem = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CourseCompletedItem, _Component);

  function CourseCompletedItem() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CourseCompletedItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CourseCompletedItem)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "item", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "onSelected", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "asLink", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(CourseCompletedItem, [{
    key: "renderRewards",
    value: function renderRewards() {
      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "success",
        overlay: "check"
      }, "You have completed ", _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), " and earned ", _react.default.createElement(RewardList, {
        rewards: this.item.details.rewards
      }), "!");
    }
  }, {
    key: "renderBare",
    value: function renderBare() {
      return _react.default.createElement(_List.NotificationItem, {
        asLink: this.asLink,
        onSelected: this.onSelected,
        item: this.item,
        overlayType: "success",
        overlay: "check"
      }, "You have completed ", _react.default.createElement("span", {
        className: "catalogItem"
      }, this.item.catalogItem.title), "!");
    }
  }, {
    key: "render",
    value: function render() {
      return this.item.details.rewards.length ? this.renderRewards() : this.renderBare();
    }
  }]);
  return CourseCompletedItem;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "onSelected", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "asLink", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
})), _class);
exports.default = CourseCompletedItem;